import { createSelector } from 'reselect'

const getWorkflowStatuses = ({ workflowStatus }) => workflowStatus.records

const getWorkflowStatusByName = ({ workflowStatus }, name) =>
  workflowStatus.records.find((workflowStatus) => workflowStatus?.value?.name === name)

const workFlowStatusesSelectors = {
  getWorkflowStatusOptions: createSelector([getWorkflowStatuses], (workflowStatuses) => {
    if (!workflowStatuses.length) {
      return []
    }
    return workflowStatuses.map((workflowStatus) => {
      return { label: workflowStatus.value.name, value: workflowStatus.value }
    })
  }),

  getWorkflowStatusByName: createSelector(
    [getWorkflowStatusByName],
    (workflowStatus) => workflowStatus,
  ),
}

export default workFlowStatusesSelectors
